import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=4748ce6c&scoped=true&"
import script from "./TicketDetail.vue?vue&type=script&lang=js&"
export * from "./TicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetail.vue?vue&type=style&index=0&id=4748ce6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4748ce6c",
  null
  
)

export default component.exports